import script from "./TraitPicker.vue?vue&type=script&setup=true&lang=js"
export * from "./TraitPicker.vue?vue&type=script&setup=true&lang=js"

import "./TraitPicker.vue?vue&type=style&index=0&id=55cca2a7&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-55cca2a7"]])

export default __exports__